import styled from 'styled-components';
import { linkLoud, formInputBackgroundColor, focusOutlineColor, focusOutlineStyle, focusOutlineWidth, focusOutlineOffset } from '@nib-components/theme';
import React from 'react';
import { HyperlinkSystemIcon, PdfSystemIcon } from '@nib/icons';
import { my, py, Margin, px } from '@nib/layout';
import slugify from 'slugify';
import Link from '@nib-components/link';
import { Box, breakpoint } from '@nib/layout';
//todo: needs unit tests
const FileLink = styled.a`
  display: block;
  border-radius: 2px;
  background-color: ${formInputBackgroundColor};
  text-decoration: none;
  ${my(2)};
  ${px(3)};
  ${py(4)};

  ${breakpoint('md')`
  display: inline-block;
  ${px(5)};
`}

  &:focus {
    outline: ${focusOutlineWidth} ${focusOutlineStyle} ${focusOutlineColor};
    outline-offset: ${focusOutlineOffset};
  }
`;
export const LinkList = styled.ul`
  padding: 0;
  list-style: none;
`;
const IconWrapper = styled.div`
  line-height: 1;
  color: ${linkLoud};
`;
const getIcon = iconType => {
  const icons = {
    URL: React.createElement(HyperlinkSystemIcon, null),
    PDF: React.createElement(PdfSystemIcon, null)
  };
  if (icons[iconType]) {
    return icons[iconType];
  }
  return '';
};
export const LinkListItem = _ref => {
  let {
    item
  } = _ref;
  return React.createElement("li", null, React.createElement(FileLink, {
    href: item.link,
    id: `ga-inline-${slugify(item.text)}`,
    target: "_blank"
  }, React.createElement(Box, {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center"
  }, React.createElement(Margin, {
    right: 3
  }, React.createElement(IconWrapper, null, getIcon(item.iconType))), React.createElement(Link, {
    component: "span"
  }, item.text, " ", item.iconType === 'PDF' && `(${item.iconType.toLowerCase()})`))));
};